import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { useEffect } from 'react'

/**
 * TextContentChangePlugin - Lexical best practice for text change detection
 *
 * Uses registerTextContentListener which ONLY fires when plain text changes,
 * automatically ignoring selection/cursor changes.
 *
 * Reference: .local_docs/lexical/core-docs/04-updates-and-transforms.md line 37
 */
export function TextContentChangePlugin({
  onChange
}: {
  onChange: (textContent: string) => void
}) {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    // THE ONLY correct way to detect text changes in Lexical
    // This listener only fires when plain text changes (ignores selection)
    return editor.registerTextContentListener((textContent) => {
      onChange(textContent)
    })
  }, [editor, onChange])

  return null
}
